import type { Customer } from '../api/common/model/customer';

const hasUnstructuredAddress = (billingAddress: Customer['billingAddress']): boolean =>
  billingAddress?.unstructuredAddress !== undefined && billingAddress?.unstructuredAddress !== null;

const hasNewAddress = (billingAddress: Customer['billingAddress']): boolean =>
  billingAddress?.addressLine1 !== undefined && billingAddress?.addressLine1 !== null;

export const shouldMigrateAddress = (billingAddress?: Customer['billingAddress']): boolean =>
  billingAddress !== undefined &&
  hasUnstructuredAddress(billingAddress) &&
  !hasNewAddress(billingAddress);
